import { Item } from "../../../shared/types/item";
import ProductCardCss from "./product-card.module.css";
import FurnitureSet from "../../../../../coworker-app/src/assets/svg/furniture-set.svg";
import { FurnitureSetWrapper } from "@coworker/app/src/components/RoomSettings/Atoms/FurnitureSetWrapper";
import { isLocalCombinationArticle } from "@coworker/app/src/components/RoomSettings/Helpers/articleHelpers";
import { ArticleType } from "@coworker/types/lib/tasks/constants";

export const ProductImage = ({ product }: { product: Item }) => {
  if (
    !product.smallImageUrl &&
    !isLocalCombinationArticle(product.type as ArticleType)
  ) {
    return <div className={ProductCardCss["product-image-placeholder"]} />;
  }

  return (
    <>
      {isLocalCombinationArticle(product.type as ArticleType) ? (
        <FurnitureSetWrapper>
          <img
            src={FurnitureSet}
            alt="Furniture Set"
            style={{ width: "24px", height: "24px" }}
          />
        </FurnitureSetWrapper>
      ) : (
        <img
          src={product.smallImageUrl}
          alt={product.name}
          width="73"
          height="73"
        />
      )}
    </>
  );
};
